import { Theme } from '@material-ui/core';

/**
 * A withStyles helper for mobile breakpoint
 *
 * theme.breakpoints.down/up shortcut
 *
 * @example
 * const styles = withStyles({ root: { color: 'blue', [breakpointMobile(theme)]: { color: 'red' }}});
 * // will style color blue for desktop, and red for mobile devices
 */
export const breakpointMobile = (theme: Theme) => {
  return theme.breakpoints.down('sm');
};
